// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style: none;
}

.link-pointer {
  cursor: pointer;
}

.pos-bottom {
  background: white;
  position: fixed;
  bottom: 3.6rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
}

.total-row {
  background-color: #777777 !important;
  font-weight: bold;
  color: #fff !important;
}

.btnRight {
  margin-right: 1px;
}

.payment-details-table tr, .payment-details-table td, .payment-details-table th {
  padding: 10px 30px;
}
.payment-details-table td:first-child {
  font-weight: 600;
}
.payment-details-table th {
  font-weight: 600;
}

.charge-succeeded {
  color: #0F9D58;
  font-weight: 600;
}

.charge-succeeded:hover {
  color: white;
}

.charge-pending {
  color: #1a7fcb;
  font-weight: 600;
}

.pos-bottom {
  background: rgba(250, 252, 252, 0.8);
  position: fixed;
  bottom: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
}

.total-row {
  background-color: #EAEBED !important;
  font-weight: bold;
  color: #777777 !important;
}

.charge-pending:hover {
  color: white;
}

.charge-failure {
  color: #721c24;
  font-weight: 600;
}

.charge-failure:hover {
  color: white;
}

.payment-receipt {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.payment-receipt:hover {
  color: white;
}

.flex-center-hor {
  display: flex;
  align-items: center;
}

.flex-center-ver {
  display: flex;
  justify-content: center;
}

.dollar-sign {
  top: -1rem;
  left: -5px;
}

.xml-icon-size {
  font-size: 27px;
  padding-right: 4px;
}

.copy-message {
  color: #76d0f5;
  font-size: 1rem;
  position: absolute;
  top: 3rem;
}

.trackerLinkCSS {
  margin-left: -140px;
  color: #357ebd;
}

.subtitle {
  font-size: 14px;
  color: #666;
  position: relative;
  top: -16px;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  /* Additional styling properties */
}`, "",{"version":3,"sources":["webpack://./src/app/orders/order-details/order-details.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AAFF;;AAKA;EACE,oCAAA;EACA,iBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAME;EACE,kBAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;;AASA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;EACI,oCAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AANJ;;AASA;EACI,oCAAA;EACA,iBAAA;EACA,yBAAA;AANJ;;AASA;EACE,YAAA;AANF;;AASA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;AANF;;AASA;EACE,UAAA;EACA,UAAA;AANF;;AASA;EACE,eAAA;EACA,kBAAA;AANF;;AASA;EACE,cC1Ga;ED2Gb,eC3Fe;ED4Ff,kBAAA;EACA,SAAA;AANF;;AASA;EACE,mBAAA;EACA,cAAA;AANF;;AASA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,iDAAA;EACA,kCAAA;AANF","sourcesContent":["@import '../../../scss/variables';\n@import '../../../scss/mixins';\n\nul {\n  list-style: none;\n}\n\n.link-pointer {\n  cursor: pointer;\n}\n\n.pos-bottom {\n  background: white;\n  position: fixed;\n  bottom: 3.6rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  width: 100%;\n}\n\n.total-row {\n  background-color: $secondary-font-color !important;\n  font-weight: bold;\n  color: $background-color !important;\n}\n\n.btnRight {\n  margin-right: 1px;\n}\n\n.payment-details-table {\n  & tr, td, th {\n    padding: 10px 30px;\n  }\n\n  & td:first-child {\n    font-weight: 600;\n  }\n\n  & th {\n    font-weight: 600;\n  }\n}\n\n.charge-succeeded {\n  color: #0F9D58;\n  font-weight: 600;\n}\n\n.charge-succeeded:hover {\n  color: white;\n}\n\n.charge-pending {\n  color: #1a7fcb;\n  font-weight: 600;\n}\n\n.pos-bottom{ \n    background: rgba(250, 252, 252, 0.8);\n    position:fixed;\n    bottom:2rem;\n    padding-top:1rem;\n    padding-bottom:1rem;\n    width:100%;\n}\n\n.total-row{\n    background-color: \t#EAEBED !important;\n    font-weight: bold;\n    color: #777777 !important;\n}\n\n.charge-pending:hover {\n  color: white;\n}\n\n.charge-failure {\n  color: #721c24;\n  font-weight: 600;\n}\n\n.charge-failure:hover {\n  color: white;\n}\n\n.payment-receipt {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.payment-receipt:hover {\n  color: white;\n}\n\n.flex-center-hor {\n  display: flex;\n  align-items: center;\n}\n\n.flex-center-ver {\n  display: flex;\n  justify-content: center;\n}\n\n.dollar-sign{\n  top: -1rem;\n  left: -5px;\n}\n\n.xml-icon-size {\n  font-size: 27px;\n  padding-right: 4px;\n}\n\n.copy-message {\n  color: $accept-color;\n  font-size: $body-font-size;\n  position: absolute;\n  top: 3rem;\n}\n\n.trackerLinkCSS {\n  margin-left: -140px;\n  color: #357ebd;\n}\n\n.subtitle {\n  font-size: 14px;\n  color: #666;\n  position: relative;\n  top:-16px;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  /* Additional styling properties */\n}","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
